import { Component, OnInit } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { Filter } from 'src/app/models/power-bi/filter'
import { BannerService } from 'src/app/services/banner/banner.service'
import { ClientService } from 'src/app/services/client/client.service'
import { PreviousRouteService } from 'src/app/services/previous-route/previous-route.service'
import { CommonService } from 'src/app/services/common/common.service'
import { ClientInformationAttribute } from '../../../models/client-information/ClientInformationAttribute'
import { FeaturesService } from '../../../services/features/features.service'
import { ClientDto } from '../../../models/client/client-dto'
import moment from 'moment'

@Component({
  selector: 'app-flip-individual-graph',
  templateUrl: './flip-individual-graph.component.html',
  styleUrls: ['./flip-individual-graph.component.scss'],
  standalone: false,
})
export class FlipIndividualGraphComponent implements OnInit {
  _clientName: string = 'Loading...'
  _flipFilters: Filter[]
  _age: string = ''
  _dob: Date
  _clientId: string
  _client: ClientDto
  //Client Attributes
  _clientInformationAttributes: ClientInformationAttribute[] =
    this.commonService.createEmptyAttributeList()
  _clientInformationTitle = 'Client Information'
  _clientInformationDisplayText = ''
  _clientInformationUrl = ''
  _clientInFocus: string = ''
  _clientEditEnabled: boolean = false //Perform check based on Feature Flag
  _totalReviews = 0
  _hasAccess: any = {
    slatHasAccess: false,
    flipHasAccess: false,
    reddiHasAccess: false,
  }

  constructor(
    private readonly router: ActivatedRoute,
    private readonly clientService: ClientService,
    private readonly bannerService: BannerService,
    private readonly previousRouteService: PreviousRouteService,
    private readonly commonService: CommonService,
    public featureService: FeaturesService,
  ) {}

  ngOnInit(): void {
    this.router.paramMap.subscribe((paramMap) => {
      const clientId = paramMap.get('clientId')
      if (!this.commonService.isValidUUID(clientId)) {
        this.bannerService.showBanner(
          `Invalid clientId ${clientId}.`,
          'error',
          30000,
        )
        throw new Error('Invalid ClientId')
      }

      this._clientId = clientId
      this.clientService.Details(clientId).subscribe({
        next: (clientDetails) => {
          this._clientName = clientDetails.preferredFullName
          this._age = clientDetails.age
          this._dob = clientDetails.dateOfBirth
          this._client = clientDetails
          this.setClientInformation(clientDetails)

          this.checkToolsAccess()
        },
        error: (err) => {
          this.bannerService.showBanner(
            'An error occured while retrieving the client details.',
            'error',
            300000,
          )
          throw err
        },
      })

      this._flipFilters = [
        {
          attribute: 'Client/contactid',
          operation: 'eq',
          value: clientId,
        },
      ]
    })
  }

  routerLinkClicked() {
    const prevUrl = this.previousRouteService.getPreviousUrl()
    if (prevUrl) {
      this.previousRouteService.goToPreviousUrl(prevUrl)
    }
  }

  setClientInformation(client: ClientDto) {
    this._clientInFocus = client.contactId
    this._clientInformationDisplayText = this._clientEditEnabled
      ? 'Edit profile'
      : ''
    this._clientInformationUrl = this._clientEditEnabled
      ? '/edit-client/' + client.contactId
      : ''

    this.commonService.setAttribute(
      this._clientInformationAttributes,
      'Age',
      client.age,
    )
    this.commonService.setAttribute(
      this._clientInformationAttributes,
      'DOB',
      moment(client.dateOfBirth).format('Do MMMM, YYYY'),
    )
    this.commonService.setAttribute(
      this._clientInformationAttributes,
      'Gender',
      client.genderCodeName,
    )
    this.commonService.setAttribute(
      this._clientInformationAttributes,
      'Case Manager',
      client.clientCaseManagerName,
    )
  }

  checkToolsAccess() {
    this._hasAccess.flipHasAccess = this.commonService.clientHasAccessToFlip(
      this._client,
    )
    this._hasAccess.reddiHasAccess = this.commonService.clientHasAccessToReddi(
      this._client,
    )
    this._hasAccess.slatHasAccess = this.commonService.clientHasAccessToSlat(
      this._client,
    )
  }
}
